import React, { Component } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import ErrorLabel from '../../../components/ErrorLabel/ErrorLabel';
import css from '../CreateNewLead/CreateNewLeads.module.scss';
import axios from 'axios';
import { connect } from 'react-redux';
import {EMAIL_REGEX} from "../../../constants";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/dark.css";
import Script from 'react-load-script';
import _ from 'lodash';
import { Link } from "react-router-dom";
import Modal from 'react-modal';


//  TODO: add validation banner for failed POST request
/**
 * @class
 */
const CreateNewLeadSR = class extends Component {
    // ---------- class fields: ----------
    source = axios.CancelToken.source();

    // The 'preferred notes' has fixed options -- so it's stored as a class field; we need to query  for the other dropdown options
    optionsPreferredNotes = [
        {label: 'Not In Home', value: 'Not In Home'},
        {label: 'In Home', value: 'In Home'}
    ];

    // ---------- state: ----------
    state = {
        optionsLeadPurpose: [],
        optionsRateChange: [],
        optionsInterestRate: [],
        optionsPreferredFinancier: [],
        optionsPreferredType: [],
        optionsPreferredFullDeal: [],
        optionsPreferredEscalator: [],
        prelimAppointmentTime: '',
        addressAutocomplete: [],
        fName: '',
        lName: '',
        phone: '',
        street: '',
        city: '',
        state: '',
        zip: '',
        isModalOpen: false,
        disableButton: false,
        leadCreateSuccess: false,
        leadCreateFail: false
    }

    // ---------- life cycle methods: ----------
    componentDidMount() {
        const search = this.props.location.search;
        const searchParams = search.substring(1);
        const paramArray = searchParams.split("&");
        let allParams = [];

        paramArray.forEach(p => {
            let tempP = p.split("=");
            allParams.push(tempP);
        });

        allParams.forEach(p => {
            switch (p[0]) {
                case 'fname':
                    let fnameString = p[1].replace(/%20/g, ' ')
                    this.setState({fName: fnameString})
                    break;
                case 'lname':
                    let lnameString = p[1].replace(/%20/g, ' ')
                    this.setState({lName: lnameString})
                    break;
                case 'phone':
                    this.setState({phone: p[1]})
                    break;
                case 'email':
                    let emailString = p[1].replace('%40', '@')
                    this.setState({email: emailString})
                    break;
                case 'street':
                    let streetString = p[1].replace(/%20/g, ' ')
                    this.setState({street: streetString})
                    break;
                case 'city':
                    let cityString = p[1].replace(/%20/g, ' ')
                    this.setState({city: cityString})
                    break;
                case 'state':
                    this.setState({state: p[1]})
                    break;
                case 'zip':
                    this.setState({zip: p[1]})
                    break;
                default:
                    break;
            }
        });

        // We need to fetch data for dropdown options:
        axios.get(
            '/sf/lead/describeField/Preferred_Financier__c',
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const filteredFinanciers = _.filter(res.data.picklistValues, function(o) {return o.value !== 'Goodleap'});
                this.setState({
                    optionsPreferredFinancier: filteredFinanciers
                });
            });

        axios.get(
            '/sf/lead/describeField/Lead_Purpose__c',
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                this.setState({
                    optionsLeadPurpose: res.data.picklistValues
                });
            });

        axios.get(
            '/sf/lead/describeField/Rate_Change__c',
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                this.setState({
                    optionsRateChange: res.data.picklistValues
                });
            });

            axios.get(
                '/sf/lead/describeField/Interest_Rate__c',
                {
                    cancelToken: this.source.token
                })
                .then((res) => {
                    this.setState({
                        optionsInterestRate: res.data.picklistValues
                    });
                });

        axios.get(
            '/sf/lead/describeField/Preferred_Type__c',
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                this.setState({
                    optionsPreferredType: res.data.picklistValues
                });
            });

        axios.get('/sf/lead/describeField/Full_Deal_Requested__c',
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                this.setState({
                    optionsPreferredFullDeal: res.data.picklistValues
                });
            });

        axios.get('/sf/lead/describeField/Preferred_Escalator__c',
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                this.setState({
                    optionsPreferredEscalator: res.data.picklistValues
                });
            });
    }

    componentWillUnmount() {
        this.source.cancel();
    }

    handleScriptLoad = () => {
        // Declare Options For Autocomplete
        const options = {
            componentRestrictions: { country: ["us"] },
            fields: ["address_components", "geometry"],
            types: ["address"]
        };
    
        // Initialize Google Autocomplete
        /*global google*/ // To disable any eslint 'google not defined' errors
        this.autocomplete = new google.maps.places.Autocomplete(
          document.getElementById('autocomplete'),
          options,
        );
    
        // Avoid paying for data that you don't need by restricting the set of
        // place fields that are returned to just the address components and formatted
        // address.
        this.autocomplete.setFields(['address_components', 'formatted_address']);
    
        // Fire Event when a suggested name is selected
        this.autocomplete.addListener('place_changed', this.handlePlaceSelect);
      }
      
    handlePlaceSelect = () => {

        // Extract City From Address Object
        const addressObject = this.autocomplete.getPlace();
        const address = addressObject.address_components;
        const pullStreet = _.filter(address, ['types[0]', 'street_number']);
        const pullRoute = _.filter(address, ['types[0]', 'route']);
        const pullCity = _.filter(address, ['types[0]', 'locality']);
        const pullState = _.filter(address, ['types[0]', 'administrative_area_level_1']);
        const pullZip = _.filter(address, ['types[0]', 'postal_code']);

        // Check if address arrays are valid
        if(!_.isEmpty(pullStreet) && !_.isEmpty(pullRoute)) {
            this.setState(
                {
                    street: pullStreet[0].long_name + ' ' + pullRoute[0].long_name
                }
            );
        }
        if(!_.isEmpty(pullCity)) {
            this.setState(
                {
                    city: pullCity[0].long_name
                }
            );
        }
        if(!_.isEmpty(pullState)) {
            this.setState(
                {
                    state: pullState[0].short_name
                }
            );
        }
        if(!_.isEmpty(pullZip)) {
            this.setState(
                {
                    zip: pullZip[0].long_name
                }
            );
        }
    }

    render() {
        return (
            <React.Fragment>
            <Script
                url={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_API_KEY}&libraries=places`}
                onLoad={this.handleScriptLoad}
            />
            <Formik
                initialValues={{
                    FirstName: '',
                    LastName: '',
                    Phone: '',
                    Email: '',
                    Street: '',
                    City: '',
                    State: '',
                    PostalCode: '',
                    Lead_Purpose__c: '',
                    Preferred_Type__c: '',          // Preferred Type
                    Preferred_Financier__c: '',     // Preferred Financier
                    Preferred_Offset__c: '',        // Preferred Offset
                    Preferred_Escalator__c: '',     // Preferred Escalator
                    Full_Deal_Requested__c: '',     // Preferred Full Deal
                    Proposal_Notes__c: '',          // Proposal Notes
                    Prelim_Appointment_Time__c: '', // Preliminary Appointment Time
                    Rate_Change__c: '',
                    Interest_Rate__c: '',
                    Company: '',            // set equal to FirstName + LastName
                    Lead_Urgency__c: '',    // set equal to `Proposal_Notes__c`
                    Sales_Representative__c: this.props.user.apiId,
                }}

                validate={
                    (values) => {
                        const errors = {};
                        
                        if (this.state.fName && !values.FirstName.trim()) {
                            errors.LastName = 'First Name is Required';
                        }

                        if (this.state.lName === '' && !values.LastName.trim()) {
                            errors.LastName = 'Last Name is Required';
                        }

                        if (this.state.phone === '' && !values.Phone.trim()) {
                            errors.Phone = 'Phone Number is Required';
                        }

                        if (this.state.email === '' && !values.Email.trim()) {
                            errors.Email = 'Email is Required';
                        } else if (!EMAIL_REGEX.test(values.Email) && !EMAIL_REGEX.test(this.state.email)) {
                            errors.Email = 'Invalid Email Address';
                        }

                        if (!values.Street.trim()) {
                            errors.Street = 'Street Address is Required';
                        }

                        if (!values.City.trim()) {
                            errors.City = 'City is Required';
                        }

                        if (!values.State.trim()) {
                            errors.State = 'State/Provence is Required';
                        }

                        if (!values.PostalCode.trim()) {
                            errors.PostalCode = 'Zip/Postal is Required';
                        }

                        if (!values.Proposal_Notes__c.trim()) {
                            errors.Proposal_Notes__c = 'Proposal Notes are Required';
                        }

                        // n.b. we're using state to validate due to using a custom date-picker component (where we have to manage its state):
                        if (!this.state.prelimAppointmentTime) {
                            errors.Prelim_Appointment_Time__c = 'Prelim Appointment Time is Required';
                        }

                        if(this.state.fName) {
                            values.FirstName = this.state.fName;
                        }

                        if(this.state.lName) {
                            values.LastName = this.state.lName;
                        }

                        if(this.state.phone) {
                            values.Phone = this.state.phone;
                        }

                        if(this.state.email) {
                            values.Email = this.state.email;
                        }

                        if(this.state.street) {
                            values.Street = this.state.street;
                        }

                        if(this.state.city) {
                            values.City = this.state.city;
                        }

                        if(this.state.state) {
                            values.State = this.state.state;
                        }

                        if(this.state.zip) {
                            values.PostalCode = this.state.zip;
                        }

                        return errors;
                    }
                }

                onSubmit={
                    // n.b. fields are validated before `onSubmit` fires
                    (values) => {
                        this.setState({disableButton: true});
                        const payload = values;

                        // convert date-picker date to ISO date format:
                        payload.Prelim_Appointment_Time__c = this.state.prelimAppointmentTime ? new Date(this.state.prelimAppointmentTime).toISOString() : new Date().toISOString();

                        // update other properties before making POST request:
                        payload.Company = values.FirstName + ' ' + values.LastName;
                        payload.Lead_Urgency__c = values.Proposal_Notes__c;
                        
                        // create new lead then return to previous page and fetch updated records:
                        axios.post(
                            '/sf/lead/create',
                            payload,
                            {
                                cancelToken: this.source.token
                            })
                            .then((res) => {
                                this.setState({
                                    isModalOpen: true,
                                    leadCreateSuccess: true
                                })
                            })
                            .catch(err => {
                                console.log('(POST) Error in Create New Lead: \n', err)
                                this.setState({
                                    isModalOpen: true,
                                    leadCreateFail: true
                                })
                            });
                    }
                }
            >
                {/* N.b. this is a Formik Form component, not a generic html form tag: */}
                <Form>
                    {/* ----- Form controls: ----- */}
                    <div className="text-right">
                        <Link to="/leads">
                            <button className="btn btn-default" type="button">Cancel</button>
                        </Link>
                        <button className="btn btn-primary ml-2" type="submit" disabled={this.state.disableButton}>Create</button>
                    </div>

                    {/* ----- Form inputs: ----- */}
                    <div className="my-3">
                        <label className="d-block" htmlFor="FirstName">First Name*</label>
                        {
                            this.state.fName ?
                            <div>
                                <Field className={`${css.CreateNewLeads__Input} input`} type="text" name="FirstName" value={this.state.fName} />
                                <ErrorMessage name="FirstName" component={ErrorLabel} />
                            </div>
                            :
                            <div>
                                <Field className={`${css.CreateNewLeads__Input} input`} type="text" name="FirstName" />
                                <ErrorMessage name="FirstName" component={ErrorLabel} />
                            </div>
                        }
                    </div>
                    <div className="my-3">
                        <label className="d-block" htmlFor="LastName">Last Name*</label>
                        {
                            this.state.lName ?
                            <div>
                                <Field className={`${css.CreateNewLeads__Input} input`} type="text" name="LastName" value={this.state.lName} />
                                <ErrorMessage name="LastName" component={ErrorLabel} />
                            </div>
                            :
                            <div>
                                <Field className={`${css.CreateNewLeads__Input} input`} type="text" name="LastName" />
                                <ErrorMessage name="LastName" component={ErrorLabel} />
                            </div>
                        }
                    </div>
                    <div className="my-3">
                        <label className="d-block" htmlFor="Phone">Phone*</label>
                        {
                            this.state.phone ?
                            <div>
                                <Field className={`${css.CreateNewLeads__Input} input`} type="Phone" name="Phone" value={this.state.phone} />
                                <ErrorMessage name="Phone" component={ErrorLabel} />
                            </div>
                            :
                            <div>
                                <Field className={`${css.CreateNewLeads__Input} input`} type="Phone" name="Phone" />
                                <ErrorMessage name="Phone" component={ErrorLabel} />
                            </div>
                        }
                    </div>
                    <div className="my-3">
                        <label className="d-block" htmlFor="Email">Email*</label>
                        {
                            this.state.email ?
                            <div>
                                <Field className={`${css.CreateNewLeads__Input} input`} type="Email" name="Email" value={this.state.email} />
                                <ErrorMessage name="Email" component={ErrorLabel} />
                            </div>
                            :
                            <div>
                                <Field className={`${css.CreateNewLeads__Input} input`} type="Email" name="Email" />
                                <ErrorMessage name="Email" component={ErrorLabel} />
                            </div>
                        }
                    </div>
                    <div className="my-3">
                        <label className="d-block">Address Search Bar</label>
                    </div>
                    <div className="my-3 col-12">
                        <input id="autocomplete" class="form-control" type="text" placeholder="Enter Customer's Address"/>
                        <div className="text-sm">
                            (If a valid address is not found then please fill out the below fields manually)
                        </div>
                    </div>
                    <div className="my-3">
                        <label className="d-block" htmlFor="Street">Street*</label>
                        {
                            this.state.street ?
                            <div>
                                <Field className={`${css.CreateNewLeads__Input} input`} type="text" name="Street" value={this.state.street}/>
                                <ErrorMessage name="Street" component={ErrorLabel} />
                            </div>
                            :
                            <div>
                                <Field className={`${css.CreateNewLeads__Input} input`} type="text" name="Street"/>
                                <ErrorMessage name="Street" component={ErrorLabel} />
                            </div>
                        }
                    </div>
                    <div className="my-3">
                        <label className="d-block" htmlFor="City">City*</label>
                        {
                            this.state.city ?
                            <div>
                                <Field className={`${css.CreateNewLeads__Input} input`} type="text" name="City" value={this.state.city}/>
                                <ErrorMessage name="City" component={ErrorLabel} />
                            </div>
                            :
                            <div>
                                <Field className={`${css.CreateNewLeads__Input} input`} type="text" name="City"/>
                                <ErrorMessage name="City" component={ErrorLabel} />
                            </div>
                        }
                    </div>
                    <div className="my-3">
                        <label className="d-block" htmlFor="State">State/Province*</label>
                        {
                            this.state.state ?
                            <div>
                                <Field className={`${css.CreateNewLeads__Input} input`} type="text" name="State" value={this.state.state}/>
                                <ErrorMessage name="State" component={ErrorLabel} />
                            </div>
                            :
                            <div>
                                <Field className={`${css.CreateNewLeads__Input} input`} as="select" name="State">
                                    <option value="" hidden disabled></option>
                                    <option value="CA">CA</option>
                                    <option value="TX">TX</option>
                                </Field>
                                <ErrorMessage name="State" component={ErrorLabel} />
                            </div>
                        }
                    </div>
                    <div className="my-3">
                        <label className="d-block" htmlFor="PostalCode">Zip/Postal Code*</label>
                        {
                            this.state.zip ?
                            <div>
                                <Field className={`${css.CreateNewLeads__Input} input`} type="text" name="PostalCode" value={this.state.zip}/>
                                <ErrorMessage name="PostalCode" component={ErrorLabel} />
                            </div>
                            :
                            <div>
                                <Field className={`${css.CreateNewLeads__Input} input`} type="text" name="PostalCode"/>
                                <ErrorMessage name="PostalCode" component={ErrorLabel} />
                            </div>
                        }
                    </div>
                    <div className="my-3">
                        <label className="d-block" htmlFor="Lead_Purpose__c">Lead Purpose</label>
                        <Field className={`${css.CreateNewLeads__Input} input`} as="select" name="Lead_Purpose__c">
                            {/* N.b. we use an empty `<option>` tag to ensure  */}
                            <option value="" hidden disabled></option>
                            { this.state.optionsLeadPurpose.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) }
                        </Field>
                    </div>
                    <div className="my-3">
                        <label className="d-block" htmlFor="Preferred_Type__c">Preferred Type</label>
                        <Field className={`${css.CreateNewLeads__Input} input`} as="select" name="Preferred_Type__c">
                            {/* N.b. we use an empty `<option>` tag to ensure  */}
                            <option value="" hidden disabled></option>
                            { this.state.optionsPreferredType.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) }
                        </Field>
                    </div>
                    <div className="my-3">
                        <label className="d-block" htmlFor="Preferred_Financier__c">Preferred Financier</label>
                        <Field className={`${css.CreateNewLeads__Input} select`} as="select" name="Preferred_Financier__c">
                            <option value="" hidden disabled></option>
                            { this.state.optionsPreferredFinancier.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) }
                        </Field>
                    </div>
                    <div className="my-3">
                        <label className="d-block" htmlFor="Preferred_Offset__c">Preferred Offset</label>
                        <Field className={`${css.CreateNewLeads__Input} input`} type="text" name="Preferred_Offset__c" />
                    </div>
                    <div className="my-3">
                        <label className="d-block" htmlFor="Preferred_Escalator__c">Preferred Escalator</label>
                        <Field className={`${css.CreateNewLeads__Input} input`} as="select" name="Preferred_Escalator__c">
                            <option value="" hidden disabled></option>
                            { this.state.optionsPreferredEscalator.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) }
                        </Field>
                    </div>
                    <div className="my-3">
                        <label className="d-block" htmlFor="Full_Deal_Requested__c">Preferred Full Deal</label>
                        <Field className={`${css.CreateNewLeads__Input} input`} as="select" name="Full_Deal_Requested__c">
                            <option value="" hidden disabled></option>
                            { this.state.optionsPreferredFullDeal.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) }
                        </Field>
                    </div>
                    <div className="my-3">
                        <label className="d-block" htmlFor="Proposal_Notes__c">Proposal Notes*</label>
                        <Field className={`${css.CreateNewLeads__Input} input`} as="select" name="Proposal_Notes__c">
                            <option value="" hidden disabled></option>
                            { this.optionsPreferredNotes.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) }
                        </Field>
                        <ErrorMessage name="Proposal_Notes__c" component={ErrorLabel} />
                    </div>
                    <div className="my-3">
                        <label className="d-block" htmlFor="Prelim_Appointment_Time__c">Prelim Appointment Time*</label>
                        {/* TODO: check Formik docs <https://formik.org/docs/api/field#children> to see if we can render custom components as Formik field; this would allow Formik to handle validation/state for us */}
                        <Flatpickr
                            name="Prelim_Appointment_Time__c"
                            data-enable-time
                            className="input w-100"
                            options={{
                                dateFormat: 'n/j/Y h:iK'
                            }}
                            value={this.state.prelimAppointmentTime}
                            onChange={date => this.setState({prelimAppointmentTime: date})}
                        />
                        <ErrorMessage name="Prelim_Appointment_Time__c" component={ErrorLabel} />
                    </div>
                    <div className="my-3">
                        <label className="d-block" htmlFor="Rate_Change__c">Rate Change</label>
                        <Field className={`${css.CreateNewLeads__Input} input`} as="select" name="Rate_Change__c">
                            {/* N.b. we use an empty `<option>` tag to ensure  */}
                            <option value="" hidden disabled></option>
                            { this.state.optionsRateChange.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) }
                        </Field>
                    </div>
                    <div className="my-3">
                        <label className="d-block" htmlFor="Interest_Rate__c">Interest Rate</label>
                        <Field className={`${css.CreateNewLeads__Input} input`} as="select" name="Interest_Rate__c">
                            {/* N.b. we use an empty `<option>` tag to ensure  */}
                            <option value="" hidden disabled></option>
                            { this.state.optionsInterestRate.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) }
                        </Field>
                    </div>

                    {/* ----- Form controls: ----- */}
                    <div className="text-right">
                        <Link to='/leads'>
                            <button className="btn btn-default" type="button">Cancel</button>
                        </Link>
                        <button className="btn btn-primary ml-2" type="submit" disabled={this.state.disableButton}>Create</button>
                    </div>
                </Form>
            </Formik>
            <Modal
                isOpen={this.state.isModalOpen}
                className="ReactModal"
                overlayClassName="ReactModal__Overlay"
            >
            {   
                this.state.leadCreateSuccess ? 
                <div className="mt-3 text-center">
                    <h2>Lead Created Successfully</h2>
                    <Link to='/leads'>
                        <button className="btn btn-primary" type="button">Continue</button>
                    </Link>
                </div>
                :
                ''
            }
            {
                this.state.leadCreateFail ?
                <div className="mt-3 text-center">
                    <h2>Lead Failed to Create</h2>
                    <p>This could be due to duplicate leads or incorrect customer data.<br></br>Please reach out to Sales Support for more information.</p>
                    <Link to='/leads'>
                        <button className="btn btn-primary" type="button">Continue</button>
                    </Link>
                </div>
                :
                ''
            }
            </Modal>
            </React.Fragment>
        );
    }
}


// ---------- Redux mapping: ----------
const mapStateToProps = state => {
    return {
        user: state.user
    };
};

export default connect(mapStateToProps)(CreateNewLeadSR);
